import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NotSynced from './icon-not-synced.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NotSynced {...validProps} />;
}
SvgComponent.iconName = 'notSynced';

export const NotSyncedIcon = svgIconWrapper(SvgComponent);
